import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { HttpErrorMessageHelper } from '@edl-development/edl-common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import SignaturePad from "signature_pad";
import { SignatureService } from 'src/app/services/signatures.service';

@Component({
  selector: 'paetep-signature-modal',
  templateUrl: './signature-modal.component.html',
  styleUrls: ['./signature-modal.component.scss']
})
export class SignatureModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() label: string = '';

  @ViewChild("signature", { static: true }) signature?: ElementRef;
  @ViewChild("sigImg", { static: true }) sigImg?: ElementRef;

  sigPad?: SignaturePad;
  prevSig?:string;
  thisVisible: boolean = true;
  clearSignatureFlag = false;


  constructor(
    public activeModal: NgbActiveModal,
    public signatureService: SignatureService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.resizeCanvas();
    firstValueFrom(this.signatureService.getSignature())
    .then((e:any) => {

      var img = this.sigImg!.nativeElement;
      var canvas = this.signature?.nativeElement;

      if(e.display != null){
        this.prevSig = e.display.replace(/\\/g, '');
        var svg64 = btoa(this.prevSig!);
        var b64Start = 'data:image/svg+xml;base64,';
        var image64 = b64Start + svg64;

        const ratio = this.getCanvasRatio();
        this.sigPad = new SignaturePad(canvas);
        this.sigPad.fromDataURL(image64, { ratio });


      } else {
        this.sigPad = new SignaturePad(canvas);
      }



    }).catch((err) => this.toastr.error(HttpErrorMessageHelper.getErrorMessage(err)));

  }

  resizeCanvas() {
    var canvas = this.signature?.nativeElement;
    
    const ratio = this.getCanvasRatio();

    // This part causes the canvas to be cleared
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);

  }

 /*
  * When zoomed out to less than 100%, for some very strange reason,
  * some browsers report devicePixelRatio as less than 1
  * and only part of the canvas is cleared then.
  */
  private getCanvasRatio = () => Math.max(window.devicePixelRatio || 1, 1);

  clearSignature(){
    this.clearSignatureFlag = true;
    this.sigPad?.clear();
  }


  cancel() {
    this.activeModal.dismiss();
  }

  saveSignature(){


      let svg = this.sigPad!.toSVG();

      let userSign =  this.prevSig && this.prevSig != "" ? this.mergeSVG(this.prevSig!, svg): svg;

      this.activeModal.close(userSign);
  }

  mergeSVG(source:string, update:string){
    // merge previous and edits
    const svgRegex: RegExp = /<svg\b[^>]* .*?>/i;
   // let header = svgRegex.exec(update);

    const regexp = /<svg\b[^>]*?>([\s\S]*?)<\/svg>/g;
    const originalSVG = this.clearSignatureFlag ? "" : source.matchAll(regexp);
    const newSVG = update.matchAll(regexp);


    let previousContent = "";
    let newContent = "";

    for (const match of originalSVG) {
      previousContent = match[1];
    }
    for (const match of newSVG) {
      newContent = match[1];
    }


    let header = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 500 200" width="500" height="200">';

    if (newContent == "") return source;
    else return header+previousContent+newContent+"</svg>";

  }

}
